import { Flex, Text, Color } from "src/elements";
import { Draggable } from "../Draggable/Draggable";
import { DragBounds } from "../../store/types";
import styled from "styled-components";
import hexToRgba from "hex-to-rgba";
import { PlanogramContainerCommonNonCircular } from "@CommonTypes/merchflow/pog/container";

const ProductHeightMetOverlay = styled(Flex)<{ color: string }>`
  position: absolute;
  inset: 0;
  background-image: ${({ color }) => `repeating-linear-gradient(
    45deg,
    ${color} 0,
    ${color} 2px,
    transparent 2px,
    transparent 10px
  );`}
  pointer-events: none;
`;

interface Props {
  container: PlanogramContainerCommonNonCircular & { label: string };
  scaleX: number;
  scaleY: number;
  bounds?: DragBounds;
  snappables: DragBounds[];
  isDraggable?: boolean;
  isResizeable?: boolean;
  isInvalid?: boolean;
  isHoverSensitive?: boolean;
  isMinProductHeightMet: boolean;
  isMaxProductHeightMet: boolean;
  onModify: (modification: DragBounds) => void;
  onEnter: () => void;
  onLeave: () => void;
  onContext: (event: React.MouseEvent<HTMLDivElement>) => void;
}

export const Container = ({
  container,
  scaleX,
  scaleY,
  bounds,
  snappables,
  isDraggable,
  isResizeable,
  isInvalid,
  isHoverSensitive,
  isMinProductHeightMet,
  isMaxProductHeightMet,
  onModify,
  onEnter,
  onLeave,
  onContext,
}: Props) => {
  return (
    <Draggable
      uniqueId={container.uniqueId}
      testId="container"
      xLeft={container.xLeft}
      xRight={container.xRight}
      yBottom={container.yBottom}
      yTop={container.yTop}
      scaleX={scaleX}
      scaleY={scaleY}
      color={container.color}
      bounds={bounds}
      snappables={snappables}
      isDraggable={isDraggable}
      isResizeable={isResizeable}
      isHoverSensitive={isHoverSensitive}
      onModify={onModify}
      onEnter={onEnter}
      onLeave={onLeave}
      onContext={onContext}
      overflow="hidden"
    >
      {!isMinProductHeightMet ? (
        <ProductHeightMetOverlay color={hexToRgba(Color.red, 0.5)} />
      ) : !isMaxProductHeightMet ? (
        <ProductHeightMetOverlay color={hexToRgba(Color.black, 0.17)} />
      ) : null}

      <Flex direction="column" justify="center" position="relative" zIndex={1} pointerEvents="none">
        <Text variant="caption2" color={isInvalid ? Color.red : Color.white} textAlign="center">
          {container.label.replaceAll(/['()]/g, "")}
        </Text>

        {container.algoCurrentTargetWidth !== undefined &&
          container.algoMinTargetWidth !== undefined && (
            <>
              <Text variant="caption2" color={isInvalid ? Color.red : Color.white}>
                <Text variant="caption2" color="inherit" testId="container-algo-width">
                  {container.algoCurrentTargetWidth}
                </Text>

                <Text variant="caption2" color="inherit">
                  /
                </Text>

                <Text variant="caption2" color="inherit">
                  {container.algoMinTargetWidth}
                </Text>
              </Text>
            </>
          )}
      </Flex>
    </Draggable>
  );
};
